<template functional>
  <span class="fas fa-spinner d-inline-block spin" aria-hidden="true" :style="{ 'font-size': props.size }"></span>
</template>

<script>
export default {
  name: 'TsWaiting',
  props: {
    size: {
      default: '14px'
    }
  }
}
</script>
